import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import PreteachButton from './PreteachButton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const PreteachSlide = (props) => {
  const [isSlideActive, setIsSlideActive] = useState(false);
  const [isSlideCompleted, setIsSlideCompleted] = useState(false);
  const [completedButtons, setCompletedButtons] = useState([]);
  const splits = props.data.splits;
  const totalButtons = splits.length;
  const dispatch = useDispatch();

  // function slideVisibilityHandler() {
  // 	setIsSlideActive(! isSlideActive);
  // }

  //handle complete slide
  const slideStatusHandler = (buttonId, buttonStatus) => {
    if (buttonStatus === true) {
      setCompletedButtons((prevState) => [...prevState, buttonId]);
    }

    if (buttonStatus === false) {
      setCompletedButtons(
        completedButtons.filter((button) => button !== buttonId),
      );
    }
  };

  const checkCompletedButtons = () => {
    if (completedButtons.length === totalButtons) {
      setIsSlideCompleted(true);
    } else {
      setIsSlideCompleted(false);
    }
  };

  const checkIfActive = () => {
    if (props.slideActive === props.index) {
      setIsSlideActive(true);
    } else {
      setIsSlideActive(false);
    }
  };

  const nextSlide = (index) => {
    let newSlide = index + 1;
    props.nextSlideHandler(newSlide);
  };

  useEffect(() => {
    if (isSlideActive === true) {
      dispatch({
        type: 'setActiveSection',
        payload: { section: props.index },
      });
    }
  }, [isSlideActive]);

  //have to use useEffect here otherwise end up out of sync with state due to child element causing side effect
  useEffect(() => {
    // console.log(completedButtons)
    checkCompletedButtons();
    checkIfActive();
  }, [completedButtons, checkCompletedButtons, checkIfActive]);

  if (isSlideActive) {
    return (
      <div className="preteach__slide" key={props.slideKey}>
        {splits.map((item, index) => (
          <PreteachButton
            key={`${index}`}
            buttonKey={`${index + 1}`}
            id={`${index}`}
            data={item}
            checkSlideStatus={slideStatusHandler}
            completedButtons={completedButtons}
          />
        ))}
        {isSlideCompleted && (
          <button
            onClick={() => nextSlide(props.index)}
            className="button button--success"
          >
            <FontAwesomeIcon icon={faCheck} size="1x" />
          </button>
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default PreteachSlide;
